
import {Component, Prop, PropSync, Vue, Watch} from 'vue-property-decorator';
import {Rect} from '@/models/tobject.model';
import {domGetElemPosition} from '@/shared/dom.utils';
import {ScreenToyDocument} from '@/models/screen.model';

@Component
export default class ScreenCanvas extends Vue {
// Les props
  @Prop({default: ''}) private name!: string
  @Prop() private url!: string
  @Prop({default: false}) private hover!: boolean
  @PropSync('toys') private screenToys!: ScreenToyDocument[]
  @PropSync('toy') private hoveredToy!: ScreenToyDocument | undefined
  @Prop({default: 100}) private size!: number

  // Les propriétés calculées
  private get id() {
    return {
      topdiv: this.name + '00',
      screenImg: this.name + '10',
      canvas: this.name + '20',
      offsetdiv: this.name + '30',
      hiddenImg: this.name + '40'
    }
  }

  private get initRect(): Rect | null {
    return this.hoveredToy ? this.toyRect(this.hoveredToy) : null
  }

  // Les propriétés
  private coordsCanvas: Rect | null = null
  private currentToyRect: Rect | null = null
  private canvasCtx: CanvasRenderingContext2D | null = null

  // Les hooks
  private mounted() {
    // console.log('ScreenImage mounted')
    const imageElem = document.getElementById(this.id.screenImg) as HTMLImageElement

    imageElem.addEventListener('load', this.updateCanvas)
    window.addEventListener('resize', this.updateCanvas)
    window.addEventListener('scroll', this.updateCanvas)
  }

  // Les méthodes surveillées
  @Watch('hoveredToy')
  private onChangeInitialToy() {
    // console.log('hoveredToy')
    this.updateCanvas()
  }

  @Watch('size')
  private onChangeSize() {
    // console.log('hoveredToy')
    this.updateCanvas()
  }

  // Les méthodes d'instance
  private toyRect(toy: ScreenToyDocument): Rect {
    const coordsCanvas = this.coordsCanvas ? this.coordsCanvas : {x: 0, y: 0, width: 0, height: 0}
    return toy && toy.position ? {
      x: (toy.position.x / 100) * coordsCanvas.width,
      y: (toy.position.y / 100) * coordsCanvas.height,
      width: (toy.position.width / 100) * coordsCanvas.width,
      height: (toy.position.height / 100) * coordsCanvas.height
    } : {x: 0, y: 0, width: 0, height: 0}
  }

  private onMouseMove(e: MouseEvent) {
    // console.log(e.clientX, e.clientY)
    const coordsCanvas = this.coordsCanvas ? this.coordsCanvas : {x: 0, y: 0, width: 0, height: 0}

    if (this.hover) {
      const x = e.clientX - coordsCanvas.x
      const y = e.clientY - coordsCanvas.y
      if (!(this.currentToyRect && ScreenCanvas.isInRect(x, y, this.currentToyRect))) {
        this.hoveredToy = this.screenToys.find((t) => ScreenCanvas.isInRect(x, y, this.toyRect(t)))
        this.currentToyRect = this.hoveredToy ? this.toyRect(this.hoveredToy) : null
      }

      if (this.canvasCtx) {
        const div: HTMLDivElement = document.getElementById(this.id.topdiv) as HTMLDivElement

        if (this.currentToyRect) {
          div.style.cursor = 'pointer'
          this.canvasCtx.strokeRect(this.currentToyRect.x, this.currentToyRect.y, this.currentToyRect.width, this.currentToyRect.height)
        } else {
          div.style.cursor = 'default'
          this.canvasCtx.clearRect(0, 0, coordsCanvas.width, coordsCanvas.height)
        }
      }
    }
  }

  private onClick() {
    if (this.hover) {
      this.$emit('clicktoy', this.hoveredToy)
    }
  }

  private updateCanvas() {
    const frame: HTMLDivElement = document.getElementById(this.id.topdiv) as HTMLDivElement
    const imageElem: HTMLImageElement = document.getElementById(this.id.screenImg) as HTMLImageElement
    const canvasElem: HTMLCanvasElement = document.getElementById(this.id.canvas) as HTMLCanvasElement

    if (imageElem && canvasElem && frame) {
      // console.log(`updateCanvas  url=${this.url.length} w=${imageElem.naturalWidth}, h=${imageElem.naturalHeight}`)
      const ratio = imageElem.naturalWidth / imageElem.naturalHeight
      const squareSide = frame.clientWidth
      // console.log(`ratio=${ratio}, squareSide=${squareSide} img.h=${imageElem.naturalHeight} img.w=${imageElem.naturalWidth}`)
      if (imageElem.naturalHeight > imageElem.naturalWidth) {
        imageElem.width = ratio * squareSide
        imageElem.height = squareSide
      } else {
        imageElem.width = squareSide
        imageElem.height = squareSide / ratio
      }
      canvasElem.width = imageElem.width
      canvasElem.height = imageElem.height
      // console.log(`canvas.h=${canvasElem.height}, canvas.w=${canvasElem.width}`)
      frame.style.height = `${canvasElem.height}px`

      this.coordsCanvas = {
        ...domGetElemPosition(imageElem) as Rect,
        width: canvasElem.width,
        height: canvasElem.height
      } as Rect
      // console.log('ScreenImage updateCanvas coordsCanvas=', {...this.coordsCanvas})

      this.canvasCtx = canvasElem.getContext('2d')

      if (this.canvasCtx) {
        // console.log('updateCanvas 2')
        this.canvasCtx.strokeStyle = '#FF0000'

        if (this.hover && this.currentToyRect) {
          // console.log('updateCanvas 3')
          this.canvasCtx.strokeRect(this.currentToyRect.x, this.currentToyRect.y, this.currentToyRect.width, this.currentToyRect.height)
        }

        if (this.initRect) {
          // console.log('updateCanvas 4')
          this.canvasCtx.strokeRect(this.initRect.x, this.initRect.y, this.initRect.width, this.initRect.height)
        }
      }
    }
  }

  // Les méthodes statiques
  private static isInRect(x: number, y: number, rect: Rect) {
    return rect
        ? x > rect.x && x < (rect.x + rect.width) && y > rect.y && y < (rect.y + rect.height)
        : false
  }

}
